import Schema from 'AppReact/schema';
import { assignTech, assignVendor, admin, makeReadyCard, makeReadyColumn, inspectionTemplate } from 'types';
import { completedCard, selectedItem, selectedCatgegory } from '../../apps/admin/makeReadyBoard/types';

export default {
  card: Schema(makeReadyCard, 'object', { defaultValue: Schema(makeReadyCard).sampleData() }),
  makeReadyCategories: Schema(makeReadyColumn, 'array', { defaultValue: [] }),
  techs: Schema(assignTech, 'array', { defaultValue: [] }),
  vendors: Schema(assignVendor, 'array', { defaultValue: [] }),
  activeAdmins: Schema(admin, 'array', { defaultValue: [] }),
  completedUnitsIds: Schema('integer', 'array', { defaultValue: [] }),
  completedItemsIds: Schema(completedCard, 'array', { defaultValue: [] }),
  archivedUnitsIds: Schema('integer', 'array', { defaultValue: [] }),
  selectedItems: Schema(selectedItem, 'array', { defaultValue: [] }),
  selectedCategories: Schema(selectedCatgegory, 'array', { defaultValue: [] }),
  exceptions: Schema('string', 'array', { defaultValue: [] }),
  inspectionTemplates: Schema(inspectionTemplate, 'array', { defaultValue: [] })
};
